var Raven = require('raven-js') ;
var sentryDSN = $('meta[name=sentry-dsn]').attr('content');
var userId = $('meta[name=user-id]').attr('content');
var userEmail = $('meta[name=user-email]').attr('content');
var userContext = {};
if (userId.length) {
    userContext.id = userId;
}
if (userEmail.length) {
    userContext.email = userEmail;
}

var ravenOptions = {
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage'
  ],
  ignoreUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
  ]
};

if (sentryDSN.length > 0) {
    Raven
      .config(sentryDSN, ravenOptions)
      .setUserContext(userContext)
      .install();
}

/**
 * General methods
 */
window.getCsrfToken = function ()
{
    return $('meta[name="csrf-token"]').attr('content');
};

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

var timeoutId = null;

window.addTimeoutBuffer = function(closure, timeout) {
    if (! timeout) {
        timeout = 200;
    }
    if (timeoutId) {
        clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(closure, timeout);
};

window.isEmpty = function(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
};

/**
 * Bulk actions
 */
$(document).ready(function () {
// Fire event with the selected amount of checkboxes for bulk-action
$('input[type="checkbox"].bulk-check').change(function() {
    var selectedCount = $('input[type="checkbox"].bulk-check:checked').length;
    $('.bulk-update').trigger('bulkCheck', selectedCount);
    $('.bulk-export').trigger('bulkCheck', selectedCount);
});

// Add span element to every bulk-update element
$('.bulk-update').each(function() {
    $(this).append($('<span />', {text: ' (0)'})).prop('disabled', 'disabled');
});

// Handle check-all checkbox
$('input[type="checkbox"][name="bulk-all"]').change(function() {
    var checkboxes = $('input[type="checkbox"].bulk-check').prop('checked', $(this).is(':checked'));
    $('.bulk-update').trigger('bulkCheck', ($(this).is(':checked') ? checkboxes.length : 0));
    $('.bulk-export').trigger('bulkCheck', ($(this).is(':checked') ? checkboxes.length : 0));
});

$('.bulk-update').on('bulkCheck', function(event, count) {
    // Update value for delete button
    if (count > 0) {
        $(this).removeAttr('disabled');
        $(this).removeProp('disabled');
    } else {
        $(this).prop('disabled', 'disabled');
    }
    $('span', this).text(' (' + count + ')');

    // Update verwijderen class on button
    if($(this).val() == 'destroy') {
        (count == 0) ? $(this).addClass('verwijderen') : $(this).removeClass('verwijderen');
    }

}).on('click', function(e) {
    // Implement click action
    e.preventDefault();
    var bulkForm = $('form#bulk-update');
    if(bulkForm.length) {
        $('input[name="operation"]', bulkForm).val($(this).val());
        if($(this).val() == 'destroy' && typeof $(this).data('no-confirm') == 'undefined'){
            showSwalConfirmBox($(this), function(){
                bulkForm.submit();
            });
        }
        else{
            bulkForm.submit();
        }
    }
});

    $('.bulk-export').on('bulkCheck', function (event, count) {
    // Update value for delete button
    if (count > 0) {
      $(this).removeAttr('disabled');
      $(this).removeProp('disabled');
    } else {
      $(this).prop('disabled', 'disabled');
    }
    // $('span', this).text(' (' + count + ')');

    // Update verwijderen class on button
    // if ($(this).val() == 'destroy') {
    (count === 0) ? $(this).addClass('verwijderen') : $(this).removeClass('verwijderen');
    // }

    }).on('click', function () {
    // Implement click action
    var bulkForm = $('form#bulk-export');
    if (bulkForm.length) {
      $('input[name="type"]', bulkForm).val($(this).val());
      $('input[name="format"]', bulkForm).val($(this).data('format'));
      bulkForm.submit();
    }
    });

});
/**
 * Abilities group toggle
 */
$('input[type="checkbox"].group-toggle').change(function() {
    var groupElement = $('div[data-group="' + $(this).data('group') + '"]');
    $('input[type="checkbox"]', groupElement).prop('checked', $(this).is(':checked'));
}).each(function() {
    var groupElement = $('div[data-group="' + $(this).data('group') + '"]'),
        checkboxes = $('input[type="checkbox"].ability-toggle', groupElement),
        checkedState = (checkboxes.length == checkboxes.filter(':checked').length);

    $(this).prop('checked', checkedState);
});

$('input[type="checkbox"].ability-toggle').change(function() {
    var groupElement = $('div[data-group="' + $(this).data('group') + '"]'),
        checkboxes = $('input[type="checkbox"].ability-toggle', groupElement),
        checkedState = (checkboxes.length == checkboxes.filter(':checked').length);

    $('input[type="checkbox"][data-group="' + $(this).data('group') + '"].group-toggle').prop('checked', checkedState);
});

$(document).ready(function(){
  /**
   * Handle destroy requests
   */
  $('a.destroy-resource').on('click', function(e) {
      e.preventDefault();
      var object = $(this);
      destroyResource(object);
  });
});

window.destroyResource = function(object) {

    if(typeof object.data('no-confirm') == 'undefined'){
        showSwalConfirmBox(object, function(){
            submitResourceForm('DELETE', object)
        });
    }
    else{
        submitResourceForm('DELETE', object)
    }
};



window.showSwalConfirmBox = function(object, callback){
    swal({
        title: object.data('confirm-title') ? object.data('confirm-title') : 'Weet je dat zeker?',
        text: object.data('confirm-text') ? object.data('confirm-text') : "Deze actie is niet meer ongedaan te maken",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ja',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Nee'
    }).then(function (isConfirm) {
        if(isConfirm){
            callback();
        }
    })
};

function submitResourceForm(method, object) {
    var form = $('<form />', {action: object.attr('href'), method: 'POST'}).appendTo($('body')).hide();
    form.append($('<input />', {type: 'hidden', name: '_method', value: method }));
    form.append($('<input />', {type: 'hidden', name: '_token', value: getCsrfToken() }));
    form.submit();
}

function submitResourceFormAjax(method, object, callback){
    $.ajax({
        type: 'POST',
        url: object.attr('href'),
        data: {
            '_method': method,
            '_token': getCsrfToken()
        },
        success: function(result){
            callback(result);
        }
    });
}

/**
 * Handler for showing elements depending on form values
 */

$(document).ready(function(){
    $('[data-depend]').not(':visible').find('input, select, textarea').prop('disabled', true);

    var daterangeInputFrom =  $('.daterangepicker-input-from');
    var daterangeInputTo =  daterangeInputFrom.next();
    if(daterangeInputFrom.length > 0){

        var options = {
            inline:true,
            container: '#datepicker-container',
            alwaysOpen:true,
            format: 'YYYY-MM-DD',
            separator: ' tot ',
            singleMonth: true,
            startDate: moment().add(1, 'days').format(),
            getValue: function()
            {
                if (daterangeInputFrom.val() && daterangeInputTo.val() )
                    return daterangeInputFrom.val() + ' to ' + daterangeInputTo.val();
                else
                    return '';
            },
            setValue: function(s,s1,s2)
            {
                daterangeInputFrom.val(s1);
                daterangeInputTo.val(s2);
            },
            beforeShowDay: function(t)
            {
                var date = moment(t).format('YYYY-MM-DD');

                var valid = !(date in disabledDays);
                var _class = '';
                var _tooltip = valid ? '' : 'Alle producten al gereserveerd';

                return [valid,_class,_tooltip];
            }
        };

        if(daterangeInputFrom.data('max-days')){
            options.maxDays = daterangeInputFrom.data('max-days');
        }
        if(daterangeInputFrom.data('batch-mode')){
            var mode = daterangeInputFrom.data('batch-mode');
            options.batchMode = mode;
            options.startDate= moment().add(1, mode).startOf(mode).format();
        }
        daterangeInputFrom.dateRangePicker(options);
    }
});

$(document).ready(function () {
    $('.depend-switch').change(function(){
        var name  = $(this).attr('name');
        var value = $(this).val();
        $('[data-depend="' + name +'"]').addClass('hidden').each(function(){
            if($(this).data('depend-value') == value){
                $(this).find('input, select, textarea').prop('disabled', false)
                $(this).removeClass('hidden');
            }else{
                $(this).find('input, select, textarea').prop('disabled', true)
            }
        })
    });
});

/**
 * Handler events for files module
 */
function updateFilename(url, name, labelHolder) {
    $.ajax({
        type: 'PUT',
        url: url,
        context: {'label': labelHolder, 'name': name},
        data: {
            '_token': getCsrfToken(),
            'name': name
        },
        success: function(result) {
            if (result.success) {
                $(this.label).html(this.name);
            }
        }
    });
}

$('input[type="file"]#add-file').change(function() {
    if ($(this).val() != '') {
        $(this).closest('form')[0].submit();
    }
});

/** Documents */
$('.files-change.document').click(function() {
    var parentElements = $(this).parent().parent().siblings('.name').children().children().eq(1).children();
    if ($(this).hasClass('edit')) {
        $(this).addClass('checkmark').removeClass('edit');

        parentElements.eq(1).show();
        parentElements.eq(0).hide();
    } else {
        $(this).addClass('edit').removeClass('checkmark');

        parentElements.eq(1).hide();
        parentElements.eq(0).show();

        updateFilename(parentElements.eq(1).data('action'), parentElements.eq(1).val(), parentElements.eq(0).get(0));
    }
});

/** Images */
$('.files-change.image').click(function() {
    var parentElements = $(this).parent().parent().siblings('.name').children();
    if ($(this).hasClass('edit')) {
        $(this).addClass('checkmark').removeClass('edit');

        parentElements.eq(0).hide();
        parentElements.eq(1).show();
    } else {
        $(this).addClass('edit').removeClass('checkmark');

        parentElements.eq(1).hide();
        parentElements.eq(0).show();

        var input = $('input', parentElements.eq(1));
        updateFilename(input.data('action'), input.val(), parentElements.eq(0).get(0));
    }
});

$('.new-search').keyup(function(e){
    if(e.keyCode == 13)
    {
        $(this).next().trigger('click');
    }
});


$(document).ready(function (e) {
    if(jQuery().nestedSortable) {
        $('.js-sortable-products').nestedSortable({
            handle: 'div',
            items: 'li',
            toleranceElement: '> div',
            stop: function (e) {
                $(this).find('input:hidden').each(function (index, item) {
                    $(item).val(index);
                });
            }
        });
    }

    $('.js-location-status-switch input[type="checkbox"]').on('change', function(e) {
        var parent = $(this).parents('.js-location-status-switch-container');
        var titles = $(parent).children('.js-location-status-switch-title');
        $(titles).each(function(index, item) {
            $(item).toggleClass('hidden');
        });
    });

    $('.js-location-online-offline-switch input[type="checkbox"]').on('change', function(e) {
        var parent = $(this).parents('.js-location-online-offline-switch-container');
        var titles = $(parent).children('.js-location-online-offline-switch-title');
        $(titles).each(function(index, item) {
            $(item).toggleClass('hidden');
        });
    });

    $('.js-location-hide-assortment-offline-switch input[type="checkbox"]').on('change', function(e) {
        var parent = $(this).parents('.js-location-hide-assortment-offline-switch-container');
        var titles = $(parent).children('.js-location-hide-assortment-offline-switch-title');
        $(titles).each(function(index, item) {
            $(item).toggleClass('hidden');
        });
    });

    $('.js-delete-image').on('click', function (e) {
        e.preventDefault();

        $(this).next('input').val('');
        $(this).parents('.js-image-preview').hide();
    });

    $('.js-delete-profile-image').on('click', function (e) {
        e.preventDefault();

        $(this).next('input').val('');
        var defaultImage = $(this).parents('.js-delete-image-container').find('.js-user-profile-image-default');
        defaultImage.removeClass('hidden');
        defaultImage.next().addClass('hidden');
        defaultImage.next().next().addClass('hidden');
        $(this).addClass('hidden');
    });

    // Javascript to enable link to tab
    var url = document.location.toString();
    if (url.match('#')) {
        $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
    }

    var triggerUpload = document.getElementById('triggerUpload'),
        upInput = document.getElementById('filePicker'),
        preview = document.querySelector('.preview');
        ConImage = $('.js-delete-image-container');
        imgPreview = document.querySelector('.img-preview');

      //force triggering the file upload here...
      triggerUpload && (triggerUpload.onclick = function() {
        upInput.click();

        upInput.addEventListener('change', function() {
          imgPreview.src = URL.createObjectURL(this.files[0]);
          var upImg = ConImage.find('.js-user-profile-image-uploaded');
          var defImg = ConImage.find('.js-user-profile-image-default');
          var preImg = ConImage.find('.img-preview');
          if ( !defImg.hasClass('hidden')) {
            defImg.addClass('hidden');
          }
          if ( preImg.hasClass('hidden')){
            preImg.removeClass('hidden');
          }
          if(!upImg.hasClass('hidden')){
            upImg.addClass('hidden');
          }
        }, false);
      });

});

function athHelper() {
    var athDisplay = Cookies.get('ath-display');
    if (typeof athDisplay === 'undefined') {
        athDisplay = 3;
    }
    else if (athDisplay === 'false') {
        return;
    }

    athDisplay--;
    if (athDisplay < 1) {
        addToHomescreen({maxDisplayCount: 1});
        athDisplay = false;
    }

    Cookies.set('ath-display', athDisplay, {expires: 365});
}

athHelper();

window.mobileAndTabletcheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

var tinymceMediaLibraryCallback = function openMediaLibrary(field_name, url, type, win) {
    if(type === 'image') {
        $(win.document).find('span:contains("Verhoudingen behouden")').parent('.mce-checkbox').addClass('hidden');
    }
    var filterType = [];
    switch (type) {
        case 'media':
            filterType = [
                'audio',
                'videos'
            ];
            break;
        case 'image':
            filterType = [
                'images'
            ];
            break;
        case 'file':
            filterType = [
                'images',
                'documents',
                'audio',
                'videos'
            ];
            break;
    }
    var filters = {
        type: filterType
    };

    var searchFilters = {};
    var hasLocation = kwalitaria.location !== false;

    if(kwalitaria.location.id === undefined && hasLocation) {
        searchFilters.location = 'global';
    } else {
        searchFilters.location = kwalitaria.location.id;
    }

    MediaSelector.init(filters, searchFilters, function() {
        switch (type) {
            case 'media':
                if (this.selectedFile.preview_full_url !== this.selectedFile.full_url) {
                    $(win.document).find('label:contains("Poster")').next().children('input').val(this.selectedFile.preview_full_url);
                }
                break;
            case 'image':
                $(win.document).find('label:contains("Afbeelding omschrijving")').next().val(this.selectedFile.alt);
                var dimensionsContainer = $(win.document).find('label:contains("Afmetingen")').parent('.mce-container-body');
                dimensionsContainer.find('input')[0].value = this.selectedFile.width;
                dimensionsContainer.find('input')[1].value = this.selectedFile.height;
                break;
            case 'file':
                $(win.document).find('label:contains("Titel")').next().val(this.selectedFile.name);
                break;
        }

        win.document.getElementById(field_name).value = this.selectedFile.full_url;
    });
};

var tinymceMediaLibraryCallback2 = function openMediaLibrary2(callback, value, meta) {

    const type = meta.filetype;

    var filterType = [];
    switch (type) {
      case 'media':
        filterType = [
          'audio',
          'videos'
        ];
        break;
      case 'image':
        filterType = [
          'images'
        ];
        break;
      case 'file':
        filterType = [
          'images',
          'documents',
          'audio',
          'videos'
        ];
        break;
    }
    var filters = {
      type: filterType
    };

    var searchFilters = {};
    var hasLocation = kwalitaria.location !== false;

    if(kwalitaria.location.id === undefined && hasLocation) {
      searchFilters.location = 'global';
    } else {
      searchFilters.location = kwalitaria.location.id;
    }

    MediaSelector.init(filters, searchFilters, function() {
      let meta = {};
      switch (type) {
        case 'media':
          if (this.selectedFile.preview_full_url !== this.selectedFile.full_url) {
            meta.poster = this.selectedFile.preview_full_url;
          }
          break;
        case 'image':
          meta.alt = this.selectedFile.alt;
          // meta.width = this.selectedFile.width;
          // meta.height = this.selectedFile.height;
          break;
        case 'file':
          meta.text = this.selectedFile.name;
          break;
      }

      callback(this.selectedFile.full_url, meta);
    });
  };

window.initializeTinymce = function(selector) {
    if( typeof tinymce !== "undefined" ) {
        if (selector === undefined) {
            selector = 'textarea.js-tinymce';
        }
        let plugins = [
            'advlist autolink lists link image hr anchor pagebreak',
            'searchreplace visualblocks visualchars code',
            'insertdatetime media nonbreaking save table contextmenu directionality',
            'paste',
          ];
          let toolbar = 'undo redo styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media';

          if (!selector.includes('not(.emojis)') && selector.includes('.emojis') && !mobileAndTabletcheck()) {
            plugins.push('tinymceEmoji');
            toolbar = toolbar + ' | tinymceEmoji';
          }
        tinymce.init({
            selector: selector,
            themes: "modern",
            plugins: plugins,
            toolbar1: toolbar,
            menubar:false,
            external_plugins: {
                'tinymceEmoji': '../tinymceEmoji/plugin.js?_=1558668410',
            },
            media_alt_source: false,
            media_dimensions: false,
            convert_urls: false,
            link_class_list: [
                {title: 'None', value: ''},
                {title: 'Standaard knop', value: 'btn btn-default'},
                {title: 'Knop met pijl', value: 'btn btn-primary'}
            ],
            content_css: $('meta[name=frontend-style]').attr('content'),
            content_style: ".mce-content-body{padding-top:0; margin: 8px;} .btn{background-color: #1c2445;padding: 10px 14px;color:#fff;text-transform: uppercase;text-decoration: none; display: inline-block;} .btn.btn-primary{padding-right:50px; background:url('/assets/backend/img/icons/icon_arrow_right_white.png') no-repeat #1c2445;background-position: right 15px center;} p {margin-block-start: 10px;margin-block-end: 10px;}",
            language_url: '/assets/backend/js/langs/tinymce/nl.js',
            // file_browser_callback: tinymceMediaLibraryCallback,
            file_picker_callback: tinymceMediaLibraryCallback2,
            table_default_attributes: {
                'class': 'js-tinymce-table'
            },
            media_url_resolver: function (data, resolve) {
                var embedHtml = '<iframe src="' + data.url + '" class="js-tinymce-iframe embed-responsive-item" ></iframe>';
                resolve({html: embedHtml});
            },
        });
    }
};

$(document).ready(function() {
    initializeTinymce('textarea.js-tinymce:not(.emojis)');
    initializeTinymce('textarea.js-tinymce.emojis');

    // Javascript to make table created with tinyMCE responsive
    $('.js-tinymce-table').wrap('<div class="table-responsive"></div>');

    // Javascript to make media iFrame created with tinyMCE responsive
    $('.js-tinymce-iframe').wrap('<div class="embed-responsive embed-responsive-16by9"></div>');

    $(document).on('focusin', function(e) {
        if ($(e.target).closest(".mce-window").length) {
            e.stopImmediatePropagation();
        }
    });

  if("ontouchstart" in window){
    $('.icon-move.ui-sortable-handle').css("display", "none");
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/backend/app.js